document.querySelectorAll(".as-product-lineup__card").forEach((link) => {
  let prefetched = false;

  const prefetch = () => {
    if (prefetched) return;

    const href = link.href;
    if (!href) return;

    const prefetchLink = document.createElement("link");

    prefetchLink.rel = "prefetch";
    prefetchLink.href = href;
    prefetchLink.as = "document";

    document.head.appendChild(prefetchLink);

    prefetched = true;
  };

  link.addEventListener("mouseenter", prefetch);
  link.addEventListener("touchstart", prefetch, { passive: true });
});
